import { type JSX, type ReactNode } from 'react';
import { cn } from '../../lib/utils.ts';

/**
 * A name that came from DATA — this practice, this person, this client — set inside standing
 * HapMetrix prose.
 *
 * THE DEFECT (owner, 2026-08-20): on the consent surfaces a reader could not tell which words
 * were filled in FOR THEM from the sentence everyone sees. The undertaking they sign names
 * their practice four times in a flat block; the data-controller notice said "belong to
 * Bright Steps Therapy" in the weight of the boilerplate around it. On a surface whose whole
 * purpose is to say who is responsible for what, a reader who cannot find the party named
 * cannot check it is the right one.
 */
/*
 * ONE HOME (rule 5) — the treatment was hand-rolled in a dozen screens and omitted in a dozen
 * more. party-name-marking-completeness.test.ts fails a NEW surface that writes prose around a
 * party name without it.
 *
 * SCOPE — prose only. A heading, cell, badge or button label that is ENTIRELY the name has
 * nothing around it to be confused with.
 *
 * COLOUR — inside an already-coloured block pass that colour through `className`: `cn` is
 * tailwind-merge, so it replaces the default rather than fighting it.
 */

/** The treatment. Exported so the architecture gate pins one literal, not a copy of it. */
export const PARTY_NAME_CLASSES = 'font-medium text-foreground';

export interface PartyNameProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export function PartyName({ children, className }: PartyNameProps): JSX.Element {
  return <span className={cn(PARTY_NAME_CLASSES, className)}>{children}</span>;
}
